module.exports = __webpack_public_path__ + "img/1 (143).ec055202.png";